import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface BulkActionBarProps {
    children: ReactNode
    className?: string
    'data-testid'?: string
}

/**
 * Compact bar that surfaces bulk-selection actions at the bottom of a list.
 * Typically renders a count on the left and action buttons on the right.
 */
export function BulkActionBar({children, className, 'data-testid': testId}: BulkActionBarProps) {
    return (
        <div
            className={cn('flex items-center justify-between px-3 py-2 bg-muted/50', className)}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
